import PremiumServicesModal from '@components/PremiumServicesModal/PremiumServicesModal';

const BannerWordingAllready = {
  default: {
    title: 'Premier service sélectionné !',
    text: 'Vous pouvez ajouter deux autres services de votre choix'
  },
  second: {
    title: 'Deuxième service sélectionné !',
    text: 'Vous pouvez ajouter un troisième service de votre choix'
  },
  ready: {
    title: 'Le compte est bon !',
    text: 'Vous avez sélectionné vos trois services, vous pouvez passer à l’étape suivante '
  },
  tooMuch: {
    title: 'Limite de sélection atteinte !',
    text: 'Vous ne pouvez sélectionner qu’un maximum de trois services'
  },
  intro: "jusqu'à deux autres services gratuits"
};

const BannerWordingWish = {
  default: {
    title: 'Premier service sélectionné !',
    text: 'Vous pouvez ajouter un autre service'
  },
  ready: {
    title: 'Le compte est bon !',
    text: 'Vous avez sélectionné vos deux services, vous pouvez passer à l’étape suivante'
  },
  tooMuch: {
    title: 'Limite de sélection atteinte !',
    text: 'Vous ne pouvez sélectionner qu’un maximum de deux services'
  },
  intro: "un autre service"
};

function displayPremiumServices() {
  const form = document.getElementById('PremiumServicesForm');
  if (!form) return null;
  const services = form.querySelectorAll('[name="services[]"]');
  const mainFieldSet = document.getElementById('js-checkbox-fieldset');
  const agriTestingInput = document.getElementById('agri_testing');
  const insitialServices = findCheckedServices(services);

  manageBanner(insitialServices?.length || 0, document.querySelector('[name="type_profil"]:checked')?.value);

  displaySelectedServices(insitialServices);

  if(document.querySelector('[name="type_profil"]:checked')) {
    mainFieldSet?.classList.remove('hidden');
    agriTestingInput.checked = true;
    displayServicesByType(services);
  }

  form.addEventListener('change', (e) => {
    e.preventDefault();

    if (e.target.matches('[name="type_profil"]')) {
      mainFieldSet?.classList.remove('hidden');
      agriTestingInput.checked = true;

      [...services].filter(service => service.id !== agriTestingInput.id).forEach((service) => (service.checked = false));
      manageBanner(findCheckedServices(services)?.length, e.target.value);
      displayServicesByType(services);
      displaySelectedServices(findCheckedServices(services));

      window.location.href= "#"+form.id;
    }
  });

  services.forEach((service) => {
    service.addEventListener('change', (e) => {
      const selectedServicesCount = findCheckedServices(services)?.length || 0;
      manageBanner(selectedServicesCount,document.querySelector('[name="type_profil"]:checked')?.value);
      if (selectedServicesCount > 3) {
        e.target.checked = false;
      }
      displaySelectedServices(findCheckedServices(services));
    });
  });
}
displayPremiumServices();

function findCheckedServices(services) {
  return [...services].filter((service) => service.checked);
}

function manageBanner(count, type) {
  let wording = 'default';

  if (type ===  "wish") {
    switch (count) {
      case 0:
        wording = 'hidden';
        break;
      case 1:
        wording = 'default';
        break;
      case 2:
        wording = 'ready';
        break;
      case 3:
        wording = 'tooMuch';
        break;
      default:
        wording = 'default';
        break;
    }
  }
  else {
    switch (count) {
      case 0:
        wording = 'hidden';
        break;
      case 1:
        wording = 'default';
        break;
      case 2:
        wording = 'second';
        break;
      case 3:
        wording = 'ready';
        break;
      case 4:
        wording = 'tooMuch';
        break;
      default:
        wording = 'default';
        break;
    }
  }

  changeWording(wording, type);

  if (wording === 'tooMuch') {
    setTimeout(() => {
      changeWording('ready');
    }, 3000);
  }
}

function changeWording(wording, type) {
  const banner = document.getElementById('PopBanner');
  if (!banner) return null;

  const BannerWording = type === 'allready' ? BannerWordingAllready : BannerWordingWish;

  document.getElementById('js-services-count').innerText = BannerWording['intro'];

  banner.classList.add('is-visible');

  if (wording === 'hidden') {
    banner.classList.remove('is-visible');
    wording = 'default';
  }

  banner.querySelector('.PopBanner-title').innerText =
    BannerWording[wording].title;
  banner.querySelector('.PopBanner-text').innerText =
    BannerWording[wording].text;

  if (wording === 'tooMuch') {
    banner.classList.add('tooMuch');
  } else {
    banner.classList.remove('tooMuch');
  }
}


PremiumServicesModal();

function displaySelectedServices(services) {
  const list = document.getElementById('SelectedPremiumService');

  if (!list) return null;

  list.innerHTML = '';

  services.forEach((service) => {
    const li = document.createElement('li');
    li.innerText = service.dataset.title;
    list.appendChild(li);
  });
}


function displayServicesByType(services) {
  const value = document.querySelector('[name="type_profil"]:checked')?.value;

  services.forEach(service => {
    if(service.dataset.type.split(',').includes(value)) {
      service.parentNode.classList.remove('hidden');
    }
    else {
      service.parentNode.classList.add('hidden');
    }
  })
}

function agritestingModal() {
  const modal = document.getElementById('agritesing-modal');
  const btns = document.querySelectorAll('.js-toggle-modal');

  if (btns.length === 0 || !modal) return null;
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (modal.classList.contains('open')) {
          modal.classList.remove('open');
          document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('relative');
          document.body.classList.remove('h-full');
          document.body.classList.remove('is-open');

          const featuresOpenButtons = document.querySelectorAll(
            '.js-openFeaturesOverlay'
          );
          featuresOpenButtons.forEach((featureButton) => {
            featureButton.classList.remove('pointer-events-none');
          });
          return;
        } else {
          modal.classList.add('open');
          document.body.classList.add('overflow-hidden');
          document.body.classList.add('relative');
          document.body.classList.add('h-full');
          document.body.classList.add('is-open');
        }
      });
    })
}
agritestingModal();
